import axios, { AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";

export const ConfigureAxios = (config?: AxiosRequestConfig): any => {
  const instance = axios.create(config);
  CustomAxiosInterceptors(instance);
  return instance;
};

const CustomAxiosInterceptors = (instance: any = axios) => {
  instance.interceptors.request.use(
    function (config) {
      // Trim string values in request data and params
      if (config.data) {
        config.data = trimObjectStrings(config.data);
      }
      if (config.params) {
        config.params = trimObjectStrings(config.params);
      }

      const existingAuth = config.headers["Authorization"];
      if (existingAuth !== undefined) {
        return config;
      }
      const token = localStorage.getItem("token");
      config.headers["Authorization"] = "Bearer " + token;
      return config;
    },
    function (error) {
      console.log("Request error: ", error);
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    response => response,
    error => {
      let res = error.response;

      if ((res.status < 200 || res.status >= 300) && res.status !== 401) {
        let message = res?.data?.message ?? (res.status == 404 ? res?.data : res.status == 400 ? res?.data : "");
        Swal.fire({
          title: "Error!",
          text: message,
          icon: "warning",
          iconColor: "#c80c0f",
          confirmButtonText: "Ok",
          confirmButtonColor: "#c80c0f",
        });
      }
      // return Promise.reject(error)
    }
  );
};

/**
 * Bir obje, dizi veya primitive değer içindeki tüm string değerleri recursive olarak trim eder.
 * DTO/Model class instance'ları, nested objeler ve dizileri işler.
 * Date, File, Blob gibi özel objeleri korur.
 */
const trimObjectStrings = (obj: any): any => {
  // Null ve undefined kontrolü
  if (obj === null || obj === undefined) return obj;

  // Primitive string'leri trim et
  if (typeof obj === "string") return obj.trim();

  // Primitive tipler (number, boolean, etc.)
  if (typeof obj !== "object") return obj;

  // Özel obje tipleri - değiştirmeden döndür
  if (
    obj instanceof Date ||
    obj instanceof File ||
    obj instanceof Blob ||
    obj instanceof RegExp ||
    obj instanceof FormData ||
    obj instanceof Map ||
    obj instanceof Set ||
    obj instanceof ArrayBuffer ||
    obj instanceof Error ||
    ArrayBuffer.isView(obj) // TypedArray'ler için (Uint8Array, Int32Array, etc.)
  )
    return obj;

  // Array'leri işle
  if (Array.isArray(obj)) return obj.map(item => trimObjectStrings(item));

  // Object'leri işle (DTO/Model class instance'ları dahil)
  const trimmed: any = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      trimmed[key] = trimObjectStrings(obj[key]);
    }
  }

  return trimmed;
};
